<app-horizontal-wrapper
  [label]="label"
  [required]="required() && !readOnly"
  [alignRight]="alignRight"
  [marginBottom]="marginBottom"
  [noCols]="noCols"
>
  <div *ngIf="modal" class="input-group">
    <span style="position: absolute; right: 10px">
      <a (click)="open(content)">
        <i class="fa-solid fa-circle-info text-primary"></i>
      </a>
    </span>
  </div>
  @if (readOnly) {
    {{ readOnlyLabel }}
  } @else {
    @for (option of selectOptions; track option.id) {
      @if (option.control) {
        <app-radio
          [type]="type"
          [id]="groupName + option.id"
          [name]="groupName + option.id"
          [label]="option.name"
          [value]="option.id"
          [control]="option.control"
          (change)="clickOption(option)"
        ></app-radio>
      } @else {
        <app-radio
          [type]="type"
          [id]="groupName + option.id"
          [name]="groupName"
          [label]="option.name"
          [value]="option.id"
          [control]="type !== 'radio' ? optionControls[option.id] : control"
          (change)="clickOption(option)"
        ></app-radio>
      }
    }
    <app-validator [control]="control" [label]="label"></app-validator>
  }
</app-horizontal-wrapper>

<ng-template #content let-modal>
  <app-modal>
    <ng-container modal-title>{{ modalTitle }}</ng-container>
    <ng-container modal-body><ng-content></ng-content></ng-container>
  </app-modal>
</ng-template>
